import { Box, Flex, Image, Text } from "@chakra-ui/core";
import React from "react";
import {
  dashNavLInks,
  investorDashNavLInks,
  mentorDashNavLInks,
} from "../../lib/utils/mock";
import { NavItem } from "./NavItem";
import { FiActivity, FiChevronDown, FiChevronUp, FiHome } from "react-icons/fi";
import { Link, NavLink, useRouteMatch } from "react-router-dom";
import { IconContext } from "react-icons/lib";
import styles from "./NavItem.module.css";
import useAuth from "../../context/AuthContext";
import { SideMenu } from "./SideMenu";

export const SideNav = React.memo(() => {
  const match = useRouteMatch();
  const [showSubMenu, setShowSubMenu] = React.useState(false);
  const [selectedIndex, setIndex] = React.useState(1);

  const onExpandNav = (idx) => {
    // console.log(selectedIndex, idx);
    // setIndex(idx);
    // selectedIndex === idx &&
    setShowSubMenu(!showSubMenu);
  };

  const {
    state: { isAuthenticated, user },
  } = useAuth();

  let sideNavlinks = null;

  if (user && user.role === "investor") {
    sideNavlinks = investorDashNavLInks;
  } else if (user && user.role === "mentor") {
    sideNavlinks = mentorDashNavLInks;
  } else sideNavlinks = dashNavLInks;

  return (
    <Flex
      direction='column'
      h='auto'
      overflow='none'
      w={["200px", "100%"]}
      mt={["40px", "0"]}
      // pr={["60px", "0"]}
    >
      {/* <NavLink
        to='/'
        exact
        activeClassName={styles.Active}
        display={["block", "none"]}
      >
        <Flex align='center' w='100%' mt='4'>
          <IconContext.Provider value={{ color: "white", size: "24px" }}>
            <Box as={FiHome} d='flex' ml='6' mb='7px'></Box>
          </IconContext.Provider>
          <Text
            fontSize={["14px", "14px"]}
            color='white'
            my='4'
            px={["5px", "20px"]}
            w='100%'
            ml='4'
          >
            Home
          </Text>
        </Flex>
      </NavLink> */}
      <NavLink to={match.url} exact activeClassName={styles.Active}>
        <Flex align='center' w='100%' mt='4'>
          <IconContext.Provider value={{ color: "white", size: "24px" }}>
            <Box as={FiActivity} d='flex' ml='6' mb='7px'></Box>
          </IconContext.Provider>
          <Text
            fontSize={["14px", "14px"]}
            color='white'
            my='4'
            px={["5px", "20px"]}
            w='100%'
            ml='4'
          >
            Dashboard
          </Text>
        </Flex>
      </NavLink>

      {sideNavlinks.map(({ name, path, icon, subMenu }, idx) => {
        if (!path) {
          return (
            <SideMenu
              menu={subMenu}
              title={name}
              icon={icon}
              match={match}
              key={idx}
            />
          );
        } else {
          return (
            <Box key={name}>
              <NavItem
                name={name}
                path={path}
                key={name}
                icon={icon}
                match={match}
              />
            </Box>
          );
        }
      })}
    </Flex>
  );
});
